export const CATALOG_TOPICS = new Set([
  "repos",
  "branches",
  "models",
  "skills",
]);
